import { FormattedMessage } from "react-intl";
import MainView from "views/MainView";

import { publicPath} from "request"

export const DeleteAccount = () => {
  return (
    <MainView backgroundClassName="bg-white dark:bg-black1b1f1e">
      <div className="break-words leading-6 p-6">
        <h3 className="font-medium text-base mb-6">
          <FormattedMessage id="deleteAccount.leading" />
        </h3>
        <p className="mt-4">
          <FormattedMessage id="deleteAccount.description1" />
        </p>
        <img
          src={`${publicPath}/images/helpCenter/en/deleteAccount/image01@2x.png`}
          alt="delete account"
          className="w-full max-w-[340px] rounded-md border border-solid border-gray-200 dark:border-gray484848 mt-6 "
        />
        <p className="mt-10">
          <FormattedMessage id="deleteAccount.description2" />
        </p>
        <img
          src={`${publicPath}/images/helpCenter/en/deleteAccount/image02@2x.png`}
          alt="delete account"
          className="w-full max-w-[340px] rounded-md border border-solid border-gray-200 dark:border-gray484848 mt-6 "
        />
        <p className="mt-10">
          <FormattedMessage id="deleteAccount.description3" />
        </p>
        <img
          src={`${publicPath}/images/helpCenter/en/deleteAccount/image03@2x.png`}
          alt="delete account"
          className="w-full max-w-[340px] rounded-md border border-solid border-gray-200 dark:border-gray484848 mt-6 "
        />
        <p className="font-medium mt-12 text-base">
          <FormattedMessage id="deleteAccount.warningLeading" />
        </p>
        <p className="font-medium mt-4 text-base">
          <FormattedMessage id="deleteAccount.warningText1" />
        </p>
        <p className="font-medium mt-4 text-base">
          <FormattedMessage id="deleteAccount.warningText2" />
        </p>
        <p className="font-medium mt-4 text-base">
          <FormattedMessage id="deleteAccount.warningText3" />
        </p>
      </div>
    </MainView>
  );
};
